import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import PropTypes from "prop-types";

const TemplateVariableUpload = ({ 
  show,
  onHide, 
  onSubmit,
  showEmailField = false 
}) => {
  const [jsonInput, setJsonInput] = useState('');
  const [emailInput, setEmailInput] = useState('');
  const [isValidJson, setIsValidJson] = useState(true);

  const handleEmailChange = (e) => {
    const input = e.target.value;
    setEmailInput(input);
  }

  const handleInputChange = (e) => {
    const input = e.target.value;
    setJsonInput(input);

    try {
      // Attempt to parse the JSON to validate it
      JSON.parse(input);
      setIsValidJson(true);
    } catch (error) {
      setIsValidJson(false);
    }
  };

  const handleSubmit = () => {
    try {
      const parsedJson = JSON.parse(jsonInput);
      if(showEmailField){ 
        onSubmit({
          "parsedJson":parsedJson,
          "email":emailInput
        });
      } else {
        onSubmit(parsedJson);
      }
      
      onHide();
    } catch (error) {
      // Handle invalid JSON
      setIsValidJson(false);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size="lg" 
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{zIndex: '2002'}}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Upload JSON Data for Email Dynamic Text / Variables
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            { showEmailField && 
            <Form.Control
              type="text"
              value={emailInput}
              onChange={handleEmailChange}
              placeholder="Recipient Email"
              className='my-3'
            /> }
            <Form.Control
              as="textarea"
              rows={10}
              value={jsonInput}
              onChange={handleInputChange}
              placeholder="Paste your JSON object here"
              className={!isValidJson ? 'is-invalid' : ''}
            />
            {!isValidJson && (
              <Form.Control.Feedback type="invalid">
                Invalid JSON format. Please check your input.
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={()=>{handleSubmit(jsonInput)}}
          disabled={!isValidJson || !jsonInput.trim()}
        >
          Create From JSON
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

TemplateVariableUpload.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onSubmit: PropTypes.func,
    showEmailField: PropTypes.bool
}

export default TemplateVariableUpload;